import React, { useEffect } from "react";
import { Box, Typography, Divider } from "@mui/material";
import ContactCard from "../../components/ContactCard/ContactCard";
import imgProfAndrew from "../../assets/Images_HubStaff/ProfAndrew.jpeg";
import imgMaeve from "../../assets/Images_HubStaff/maevelosen.jpg";
import imgAvantika from "../../assets/Images_HubStaff/Avantika1.jpeg";
import imgPhil from "../../assets/Images_HubStaff/Phill.png";
import imgJamie from "../../assets/Images_HubStaff/Jamie.jpg";
import imgKatherine from "../../assets/Images_HubStaff/Katherine_frisch.jpg";
import imgAndrewMc from "../../assets/Images_HubStaff/AndrewMcSorley.jpg";
import imgSamantha from "../../assets/Images_HubStaff/Samantha.jpg";

import { Link } from "react-router-dom";

import Tooltip from "../../components/Tooltip/Tooltip";

const About = () => {
  useEffect(() => {
    document.title = "About - MS Digital Hub";
  }, []);
  return (
    <Box
      sx={{
        width: "auto",

        padding: "0px 20px",
        margin: "0px auto",
        padding: { xs: "20px", sm: "30px", md: "1px 80px" },
        border: "none",
        backgroundColor: "#ffffff",
        borderRadius: "8px",
      }}
    >
      {/* Title 
      <Typography
variant="h5"
sx={{
marginBottom: "30px",
textAlign: "center",
display: "inline-block",
paddingBottom: "5px",
fontStyle:"italic",
fontWeight:"bold",
textShadow: "2px 2px 4px rgba(0,0,0,0.3)",
borderBottom:"2px solid #FFD700"
}}
>
        Meet Our Team
      </Typography>*/}

      <Typography
        variant="body1"
        sx={{
          marginBottom: "20px",
          lineHeight: "1.8",
          textAlign: "justify",
        }}
      >
        The Hub is housed at the{" "}
        <Tooltip
          keyword="Center for Digital Humanities"
          url="https://www.usmcdh.org/"
        />
        (CDH) in the School of Humanities at The University of Southern
        Mississippi. It is made possible by a Congressionally funded grant
        administered by the{" "}
        <Tooltip
          keyword="National Archives and Records Administration"
          url="https://www.archives.gov/"
        />
        (NARA)’s{" "}
        <Tooltip
          keyword="National Historical Publications and Records Commission"
          url="https://www.archives.gov/nhprc"
        />
        (NHPRC).
      </Typography>
      <Typography
        variant="body1"
        sx={{
          marginBottom: "30px",
          lineHeight: "1.8",
          textAlign: "justify",
        }}
      >
        The Hub was conceived by the CDH's founder and former director,{" "}
        <Tooltip keyword="Dr. Susannah Ural" url="https://susannahjural.com/" />
        , as a means of providing resources and support to Mississippi scholars
        and archivists seeking to preserve local cultural and historical
        resources. It works closely with the Center for Digital Humanities and
        the{" "}
        <Tooltip
          keyword="DigiLab"
          url="https://www.digitalcollections.usm.edu/about"
        />{" "}
        at University Libraries (at Southern Miss) to provide a resource for all
        Mississippians.
      </Typography>

      <Typography
        variant="h4"
        sx={{
          marginBottom: "30px",
          textAlign: "center",
        }}
      >
        Meet Our Team
      </Typography>
      <ContactCard
        name={
          <Tooltip
            keyword="Andrew P. Haley, Ph.D. "
            url="https://www.usm.edu/faculty-directory/profile.php?id=1936611"
          />
        }
        title="Principal Investigator"
        bio="Andrew P. Haley served as the interim director of the Center for Digital Humanities at Southern Miss in 2023-24 and now directs the Hub. Haley is a historian of the late nineteenth and early twentieth centuries whose work focuses on culture, community, and food. He has partnered with the McCain Library and Archives and the DigiLab at The University of Southern Mississippi to create an archival and online community cookbook collection, highlighting community cookbooks published in Mississippi prior to 1970."
        image={imgProfAndrew}
        email="andrew.haley@usm.edu"
        bioLink="https://www.usm.edu/faculty-directory/profile.php?id=1936611"
        linkedIn=""
      />

      <ContactCard
        name="Katherine Frisch, MLIS"
        title="Administrator"
        bio="Katherine Frisch holds a Master's degree in Library and Information Science from the University of Southern Mississippi, as well as a graduate certificate in Archives and Special Collections. She earned a Dual bachelor's degree in History and Anthropology from Mississippi State University. She has over a decade of experience in public librarianship, including serving as the former Assistant Director of the Lamar County Library System. Her professional interests include representation in collection development, innovative library programming, and community engagement. She now serves as the Manager of the Mississippi Digital Humanities Hub at USM."
        image={imgKatherine}
        email="Katherine.Frisch@usm.edu"
        bioLink=""
      />

      <ContactCard
        name={
          <Tooltip
            keyword="Samantha Stephens, Ph.D "
            url="https://www.samanthastephens.net/"
          />
        }
        title="Digital Humanities Postdoctoral Scholar"
        bio={`Dr. Samantha Stephens has joined the Mississippi Digital Humanities Hub at Southern Miss as the Digital Humanities Postdoctoral Scholar. She holds a PhD in English from the University of Virginia and a Certificate in Digital Humanities. Her research engages with race and technology, slavery and its afterlives, and Black poetry and poetics. Dr. Stephens is excited to develop and instruct the upcoming summer residency for secondary school educators and to support the network of DH programs across Mississippi through conference planning, DH programming, and public events.

From experiences in the college classroom to working on interdisciplinary teams, she has been invested in making digital humanities tools and methods accessible to people with different levels of exposure and experience. Dr. Stephens especially enjoys workshop-based learning. “I find it really satisfying to work with people hands-on — to introduce a method, troubleshoot together, and make connections between the tools and their own work,” she states. Her background in visual art also shapes her approach to digital humanities as both a creative and collaborative practice. Bringing attention to aesthetics, design, and visual storytelling, she explores how creative methods can enrich classroom experiences, foster Interdisciplinary exchange, and make scholarly ideas accessible to broader audiences.

Through her work at the Hub, she hopes to build meaningful connections across educational and cultural institutions, fostering rich dialogues and collaboration among educators, archivists, museum professionals, scholars, and students.`}
        image={imgSamantha}
        email="Samantha.L.Stephens@usm.edu"
        bioLink="https://www.samanthastephens.net/"
      />

      <ContactCard
        name="Avantika Mittapally, M.S."
        title="Digital Developer"
        bio="Avantika Mittapally is a Software Developer with experience in full-stack development, UI/UX, and digital infrastructure. She holds a Master's in Computer Science and has worked on various projects involving React, Java, Python, and cloud technologies. Currently, she’s contributing to digital humanities research at The University of Southern Mississippi, focusing on developing solutions that support digital scholarship and workshops."
        image={imgAvantika}
        email="avantika.mittapally@usm.edu"
      />

      <ContactCard
        name="Jamie O’Quinn, M.S."
        title="Public Programs and Outreach Liaison"
        bio="Jamie O’Quinn holds a Master of Science in Community Counseling from Mississippi College and a Bachelor of Science in Social and Rehabilitation Services from The University of Southern Mississippi. She is a former Training Director, Public Relations Editor, and Business Development Representative for the state where she especially enjoyed co-planning the nation’s first “Serving Native Americans with Disabilities” conference in conjunction with the Corsorita Administrators for Native American Rehabilitation and the Mississippi Band of Choctaw Indians.
As a former freelance writer, she has over 250 published articles and book contributions including stories on the step-by-step process of hand making guitars, growing up as a third-generation bull rider, and flicking sawdust out of her hair while interviewing a former tub boat captain who became the world champion chainsaw carver."
        image={imgJamie}
        email="jamie.oquinn@usm.edu"
      />
    </Box>
  );
};

export default About;
